export default  [

  {
    path: 'company/company-list',
    meta: {pageTitle: '单位管理', leftMenuIndex: 'admin_company_company-list'},
    component: () => import('@/views/admin/company/CompanyList')
  },
  {
    path: 'company/company-login-user-list',
    meta: {pageTitle: '单位登录人员管理', leftMenuIndex: 'admin_company_company-login-user-list'},
    component: () => import('@/views/admin/company/CompanyLoginUserList')
  },

  {
    path: 'company/company-count-list',
    meta: {pageTitle: '单位统计管理', leftMenuIndex: 'admin_company_company-count-list'},
    component: () => import('@/views/admin/company/CompanyCountList')
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/company.js